import React, {useState} from 'react';
import TextField from '@mui/material/TextField';
import Stack from '@mui/material/Stack';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { MobileDatePicker } from '@mui/x-date-pickers/MobileDatePicker';
import { sidebarwith } from './Const';
import { StyledEngineProvider } from '@mui/material/styles';
export default function ResponsiveDatePickers(props) {
    const {label,value,onChange}= props  
  return (
    <StyledEngineProvider injectFirst>
    <LocalizationProvider dateAdapter={AdapterDayjs}>
        <MobileDatePicker
          label={label}
          value={value}
          onChange={onChange}
          renderInput={(params) => <TextField 
            sx={{ width: sidebarwith
              
              }}
          size = 'small'
          fullWidth
          
            {...params} 
            />}
        />      
    </LocalizationProvider>
    </StyledEngineProvider>
  );
}
